import { createFileRoute } from '@tanstack/react-router';

import { ConfirmSetupPage } from 'src/apps/enterprise/app/pages/ConfirmSetup';

export const Route = createFileRoute('/_auth/enterprise/enroll/confirm-setup')({
  component: () => <ConfirmSetupPage />,
});
